import React, { useState,useEffect,useRef } from "react";
import OneImg from "../Assets/images/100.svg";
import TwoImg from "../Assets/images/52.svg";
import ThreeImg from "../Assets/images/48.svg";
import GraphOne from "../Assets/images/graph-1.png";
import TwoGraph from "../Assets/images/two.png";
import { Table } from "antd";
import { useLocation } from "react-router-dom";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";

import { Flex, Progress } from "antd";
import CircularProgressBar from "./CircularProgressBar";
import { useNavigate } from "react-router-dom";
import Heatmap from './Heatmap';
import * as d3 from "d3";
import { useSnapshot } from "./SnapshotContext";

const OverviewDasboard = () => {
  const [activeTable, setActiveTable] = useState("weekday");
  const [activeTableMonthly, setActiveTableMonthly] = useState("monthly");

  const navigate = useNavigate();

  const location = useLocation();

  const [heatmapData, setHeatmapData] = useState([]);
  const [rowNames, setRowNames] = useState([]);
  const [columnNames, setColumnNames] = useState([]);

  const [overviewData, setOverviewData] = useState(null);

  // const parkingDemandData = location.state?.parkingDemandData;
  const [parkingDemandData] = useState(location.state?.parkingDemandData || []);

   // Extract data from location.state
   const { overviewGraphDemandData } = location.state || {};

   const { addSnapshotRef, removeSnapshotRef  } = useSnapshot();
   const firstDivRef = useRef();
   const secondDivRef = useRef();
   const weekendBarGraphSnap = useRef();
   const weekdayBarGraphSnap = useRef();
   const weekdayLineGraphSnap =useRef();
   const weekendLineGraphSnap = useRef();

   
  
 
   // Register both divs
   useEffect(() => {
       // Clear previous snapshots before adding new ones
       removeSnapshotRef();
      addSnapshotRef("overviewDashboard", firstDivRef.current);
    //  addSnapshotRef("secondDiv", secondDivRef.current);
     addSnapshotRef("Heatmap", secondDivRef.current);


     if (activeTable === "weekday"){
     addSnapshotRef("weekdayBarGraphSnap", weekdayBarGraphSnap.current);
     addSnapshotRef("weekdayLineGraphSnap",weekdayLineGraphSnap.current);
     }

     if (activeTable === "weekend"){

     addSnapshotRef("weekendBarGraphSnap", weekendBarGraphSnap.current);
     addSnapshotRef("weekendLineGraphSnap",weekendLineGraphSnap.current);
     }
   }, [addSnapshotRef,removeSnapshotRef,activeTable]);

   useEffect(() => {
    if (overviewGraphDemandData) {
        setOverviewData(overviewGraphDemandData);
    }
}, [overviewGraphDemandData]);

  //  console.log("overviewGraphDemandData:", overviewGraphDemandData);
   

  // if (
  //   !parkingDemandData ||
  //   !Array.isArray(parkingDemandData) ||
  //   parkingDemandData.length === 0
  // ) {
  //   console.error("Invalid or missing parkingDemandData");
  //   navigate("/spaceSelect/planning-to-theater");
  //   return null; // To prevent further execution
  // }

  //   const weekendParkingDemandData = location.state?.graphDemandData;

  // console.log("Parking Demand Data:", parkingDemandData);

  // Extract data for the month graph
  // const monthGraphData = parkingDemandData[0]?.weekday?.month_graph;

  // Format the data for Recharts
  //   const formattedData = monthGraphData?.months.map((month, index) => ({
  //       month,
  //       peakDemand: monthGraphData.peak_monthly_distribution[index]
  //   }));

  const transformHeatmapData = (apiData) => {
    if (!apiData || apiData.length === 0)
      return { rowNames: [], columnNames: [], heatmapData: [] };

    // Extract row names (assumes all objects have the same months array)
    const rowNames = apiData[0].weekday_months;

  //   if (activeTable === "weekday")
  //   {
  //   const columnNames = apiData.flatMap((item) => [
  //     `${item.land_use_type} Weekday`,
  //     // `${item.land_use_type} Weekend`,
  //   ]);

  //   const heatmapData = rowNames.map((_, rowIndex) =>
  //     apiData.flatMap((item) => [
  //       item.weekday_peak_monthly_distribution[rowIndex],
  //       // item.weekend_peak_monthly_distribution[rowIndex],
  //     ])
  //   );
  // }else if(activeTable === "weekday"){
  //   const columnNames = apiData.flatMap((item) => [
  //     // `${item.land_use_type} Weekday`,
  //     `${item.land_use_type} Weekend`,
  //   ]);

  //   const heatmapData = rowNames.map((_, rowIndex) =>
  //     apiData.flatMap((item) => [
  //       // item.weekday_peak_monthly_distribution[rowIndex],
  //       item.weekend_peak_monthly_distribution[rowIndex],
  //     ])
  //   );

  // }

  let columnNames = [];
  let heatmapData = [];

  if (activeTable === "weekday") {
    columnNames = apiData.map(item => `${item.land_use_type} `);
    columnNames = apiData.map(item => `${item.land_use_type} `);
    heatmapData = rowNames.map((_, rowIndex) =>
      apiData.map(item => item.weekday_peak_monthly_distribution[rowIndex])
    );
  } else if (activeTable === "weekend") {
    columnNames = apiData.map(item => `${item.land_use_type} `);
    heatmapData = rowNames.map((_, rowIndex) =>
      apiData.map(item => item.weekend_peak_monthly_distribution[rowIndex])
    );
  }

    return { rowNames, columnNames, heatmapData };
  };

  useEffect(() => {
    if (!parkingDemandData || !Array.isArray(parkingDemandData) || parkingDemandData.length === 0) {
      console.error("Invalid or missing parkingDemandData");
      navigate('/spaceSelect/planning-to-theater');
      return;
    }

    const DummyData = parkingDemandData;

    // console.log("DummyData::", DummyData);

    let extractedData = [];

    console.log("DummyData::",DummyData);
    

    if (activeTableMonthly === "monthly")
    {
      extractedData = DummyData.map((item) => ({
        land_use_type: item.land_use_type,
        weekday_months: item.weekday.month_graph.months,
        // weekday_peak_monthly_distribution: item.weekday.month_graph.peak_monthly_distribution,
        weekday_peak_monthly_distribution: item.peaktable_data.weekday_peak.demand_points_monthly,
        weekend_months: item.weekend.month_graph.months,
        // weekend_peak_monthly_distribution: item.weekend.month_graph.peak_monthly_distribution,
        weekend_peak_monthly_distribution: item.peaktable_data.weekend_peak.demand_points_monthly,
      }));
    }
    else if(activeTableMonthly === "hourly")
    {
      extractedData = DummyData.map((item) => ({
        land_use_type: item.land_use_type,
        weekday_months: item.weekday.time_graph.time_labels,
        // weekday_peak_monthly_distribution: item.weekday.time_graph.peak_demand_points,
        weekday_peak_monthly_distribution: item.peaktable_data.weekday_peak.demand_points_hourly,
        weekend_months: item.weekend.time_graph.time_labels,
        // weekend_peak_monthly_distribution: item.weekend.time_graph.peak_demand_points,
        weekend_peak_monthly_distribution: item.peaktable_data.weekend_peak.demand_points_hourly,
      }));
    }
    

    let { rowNames, columnNames, heatmapData } = transformHeatmapData(extractedData);
    columnNames = columnNames.map(name => name.replace(/\s*Typical\s*$/i, '').trim());
    // console.log("columnNames::",columnNames);
    
    setRowNames(rowNames);
    setColumnNames(columnNames);
    setHeatmapData(heatmapData);

    // console.log(extractedData);
  }, [parkingDemandData, navigate,activeTable,activeTableMonthly]);

  // Process and format the data dynamically
  const formattedData = parkingDemandData.reduce((acc, item) => {
    const { land_use_type, weekday } = item;

    if (!weekday || !weekday.month_graph) {
      console.warn(`Invalid data for description: ${land_use_type}`);
      return acc;
    }

    const { months, peak_monthly_distribution } = weekday.month_graph;

    if (!Array.isArray(months) || !Array.isArray(peak_monthly_distribution)) {
      console.warn(`Incomplete data for description: ${land_use_type}`);
      return acc;
    }

    // Combine data for stacked bar graph
    months.forEach((month, index) => {
      const existingEntry = acc.find((entry) => entry.month === month);
      const peakDemand = peak_monthly_distribution[index] || 0;

      if (existingEntry) {
        existingEntry[land_use_type] = peakDemand; // Add description key to existing month
      } else {
        acc.push({
          month,
          [land_use_type]: peakDemand, // Start new entry for this month
        });
      }
    });

    return acc;
  }, []);
  // console.log("Formatted Data for Stacked Bar Graph:", formattedData);

  // const timeGraphData = parkingDemandData[0].weekday.time_graph;

    // const formattedTimeData = timeGraphData?.time_labels.map((labels,index)=>({
    //   time:labels,
    //   peakDemand:timeGraphData.peak_demand_points[index]

    // }))

  // console.log("overviewGraphDemandData::!::",overviewGraphDemandData);
  
  const combinedSummaryDataWeekDay = overviewGraphDemandData[0]?.combined_summary.weekday?.time_graph;

  const formattedTimeData = parkingDemandData.reduce((acc, item) => {
    const { land_use_type, weekday } = item;

    if (!weekday || !weekday.time_graph) {
      console.warn(`Invalid data for description: ${land_use_type}`);
      return acc;
    }

    const { time_labels, peak_demand_points } = weekday.time_graph;

    if (!Array.isArray(time_labels) || !Array.isArray(peak_demand_points)) {
      console.warn(`Incomplete data for description: ${land_use_type}`);
      return acc;
    }

    // Combine data for time-based graph
    time_labels.forEach((time, index) => {
      const existingEntry = acc.find((entry) => entry.time === time);
      const peakDemand = peak_demand_points[index] || 0;

      if (existingEntry) {
        existingEntry[land_use_type] = peakDemand; // Add land_use_type key to existing time entry
      } else {
        acc.push({
          time,
          [land_use_type]: peakDemand, // Start new entry for this time
        });
      }
    });

    return acc;
  }, []);

  const combinedSummaryTimeData = combinedSummaryDataWeekDay
  ? combinedSummaryDataWeekDay.time_labels.map((time, index) => ({
      time,
      "Combined Summary": combinedSummaryDataWeekDay.peak_demand_points[index] || 0,
    }))
  : [];

  const monthGraphWeekendData = parkingDemandData[0].weekend.month_graph;
  // console.log("monthGraphWeekendData::", monthGraphWeekendData);

  //   const formattedWeekendData = monthGraphWeekendData?.months.map((month, index) => ({
  //     month,
  //     peakDemand: monthGraphWeekendData.peak_monthly_distribution[index]
  // }));
  const combinedSummaryDataWeekEnd = overviewGraphDemandData[0].combined_summary.weekend.time_graph;

  const formattedWeekendData = parkingDemandData.reduce((acc, item) => {
    const { land_use_type, weekend } = item;

    if (!weekend || !weekend.month_graph) {
      console.warn(`Invalid data for description: ${land_use_type}`);
      return acc;
    }

    const { months, peak_monthly_distribution } = weekend.month_graph;

    if (!Array.isArray(months) || !Array.isArray(peak_monthly_distribution)) {
      console.warn(`Incomplete data for description: ${land_use_type}`);
      return acc;
    }

    // Combine data for stacked bar graph
    months.forEach((month, index) => {
      const existingEntry = acc.find((entry) => entry.month === month);
      const peakDemand = peak_monthly_distribution[index] || 0;

      if (existingEntry) {
        existingEntry[land_use_type] = peakDemand; // Add description key to existing month
      } else {
        acc.push({
          month,
          [land_use_type]: peakDemand, // Start new entry for this month
        });
      }
    });

    return acc;
  }, []);

  const combinedSummaryTimeData_Weekend = combinedSummaryDataWeekEnd
  ? combinedSummaryDataWeekEnd.time_labels.map((time, index) => ({
      time,
      "Combined Summary": combinedSummaryDataWeekEnd.peak_demand_points[index] || 0,
    }))
  : [];

  // console.log("parkingDemandData::",parkingDemandData);
  
  // console.log("overviewGraphDemandData[0].combined_summary.weekend.time_graph::",overviewGraphDemandData[0].combined_summary.weekend.time_graph);
  

  // console.log("combinedSummaryTimeData_Weekend::",combinedSummaryTimeData_Weekend);
  
  

  // console.log(
  //   "formattedWeekendData  for Stacked Bar Graph:",
  //   formattedWeekendData
  // );

  const timeGraphWeekendData = parkingDemandData[0].weekend.time_graph;

  // const formattedTimeWeekendData = timeGraphWeekendData?.time_labels.map((labels,index)=>({
  //   time:labels,
  //   peakDemand:timeGraphWeekendData.peak_demand_points[index]
  // }));

  const formattedTimeWeekendData = parkingDemandData.reduce((acc, item) => {
    const { land_use_type, weekend } = item;

    if (!weekend || !weekend.time_graph) {
      console.warn(`Invalid data for description: ${land_use_type}`);
      return acc;
    }

    const { time_labels, peak_demand_points } = weekend.time_graph;

    if (!Array.isArray(time_labels) || !Array.isArray(peak_demand_points)) {
      console.warn(`Incomplete data for description: ${land_use_type}`);
      return acc;
    }

    // Combine data for time-based graph
    time_labels.forEach((time, index) => {
      const existingEntry = acc.find((entry) => entry.time === time);
      const peakDemand = peak_demand_points[index] || 0;

      if (existingEntry) {
        existingEntry[land_use_type] = peakDemand; // Add land_use_type key to existing time entry
      } else {
        acc.push({
          time,
          [land_use_type]: peakDemand, // Start new entry for this time
        });
      }
    });

    return acc;
  }, []);

  // console.log("formattedWeekendData::", formattedWeekendData);

  // console.log("formattedTimeData::", formattedTimeData);

  // console.log("timeGraphData::", timeGraphData);

  

  const combinedSummaryData = overviewGraphDemandData.find(
    (item) => item.combined_summary
  );

  // console.log("combinedSummaryData::",combinedSummaryData);
  // console.log("columnNames!!!!!!!!::",columnNames);

  
  

  return (
    <div>
      <div className="row">
        <div className="col-lg-4">
          <div className=" card-inside-parking actual-parking-active">
            <div className="text-center m-auto">
              {/* <h4>Actual Parking</h4> */}
              <h4>Maximum Shared Parking Demand</h4>
              <h1>{combinedSummaryData?.combined_summary?.front_tiles?.Maximum_shared_parking_demand}</h1>
              {/* <h1>100</h1> */}
             
            </div>
            {/* <div>
              <CircularProgressBar 
              // percent={75}
              percent={combinedSummaryData?.combined_summary?.front_tiles?.Maximum_shared_parking_demand}
              />
            </div> */}
          </div>
        </div>
        <div className="col-lg-4">
          <div className=" card-inside-parking">
            <div className="text-center m-auto">
              {/* <h4>Shared Parking</h4> */}
              <h4>Shared Parking Reduction</h4>
              {/* <h1>{combinedSummaryData?.combined_summary?.front_tiles?.shared_parking_reduction}%</h1> */}
              <h1>
              {combinedSummaryData?.combined_summary?.front_tiles?.shared_parking_reduction
                ? Math.round(combinedSummaryData.combined_summary.front_tiles.shared_parking_reduction)
                : 0
              }%
            </h1>

              {/* <h1>52</h1> */}
              {/* <p>
                                Sample Description
                            </p> */}
            </div>
            {/* <div>
            
              <CircularProgressBar 
              // percent={50}
              percent = {combinedSummaryData?.combined_summary?.front_tiles?.shared_parking_reduction}
              />
            </div> */}
          </div>
        </div>
        <div className="col-lg-4">
          <div className=" card-inside-parking">
            <div className="text-center m-auto">
              {/* <h4>Saved Parking</h4> */}
              <h4>Total Overall Parking Demand</h4>
              <h1>{combinedSummaryData?.combined_summary?.front_tiles?.Total_overall_parking_demand}</h1>
              {/* <h1>48</h1> */}
              {/* <p>
                                Sample Description
                            </p> */}
            </div>
            {/* <div>
             
              <CircularProgressBar 
              // percent={25}
              percent={combinedSummaryData?.combined_summary?.front_tiles?.Total_overall_parking_demand}
              />
            </div> */}
          </div>
        </div>
      </div>
      <div className="row mt-3">
        {/* <div className="col-lg-12">
          <div className="card-inside">
            <div className="text-left">
              <h4>Parking Demand Summary</h4>
            </div>
            <table className="table table-bordered mt-4">
              <thead>
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3" className="text-center">
                    Weekday
                  </td>
                  <td colSpan="3" className="text-center">
                    Weekend
                  </td>
                </tr>
                <tr>
                  <td>Land Use</td>
                  <td>Total Size</td>
                  <td>Peak Month</td>
                  <td>Peak Hour</td>
                  <td>Peak Value</td>
                  <td>Peak Month</td>
                  <td>Peak Hour</td>
                  <td>Peak Value</td>
                </tr>
              </thead>
              <tbody>
                {parkingDemandData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.land_use_type}</td>
                    <td>
                      {item.project_data.quantity} {item.project_data.unit}
                    </td>
                    <td>{item.weekday.peak_month_name}</td>
                    <td>{item.weekday.peak_hour_time}</td>
                    <td style={{ background: "#F6E3D4" }}>
                      {item.weekday.peak_month}
                    </td>
                    <td>{item.weekend.peak_month_name}</td>
                    <td>{item.weekend.peak_hour_time}</td>
                    <td>{item.weekend.peak_month}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div> */}
        <div className="col-lg-6">
          <div ref={firstDivRef} className="card-inside">
            <div className="d-flex align-items-center w-100 justify-content-between">
              <div>
                <h4 className="mb-4">Parking Demand Summary</h4>
                <div className="d-flex align-items-center" style={{ borderRadius: '5px'}}>
                  {/* Weekday and Weekend buttons */}
                  <div
                    onClick={() => setActiveTable("weekday")}
                    style={{
                      cursor: "pointer",
                      padding: '18px 40px',
                      fontWeight: '300',
                      background: activeTable === "weekday" ? "#A4DEC8" : "#ECF4F5",
                      borderRadius: '5px 0 0 5px',
                    }}
                  >
                    <h4 style={{fontSize: '15px', fontWeight: '400'}} className="mb-0">Weekday</h4>
                  </div>
                  <div
                    onClick={() => setActiveTable("weekend")}
                    style={{
                      cursor: "pointer",
                      padding: '18px 40px',
                      fontWeight: '300',
                      background: activeTable === "weekend" ? "#A4DEC8" : "#ECF4F5",
                      borderRadius: '0 5px 5px 0'
                    }}
                  >
                    <h4 style={{fontSize: '15px', fontWeight: '400'}} className="mb-0">Weekend</h4>
                  </div>
                </div>
              </div>
          
              <div className="d-flex align-items-center" style={{    background: '#ECF4F580',
    padding: '10px 10px',
    borderRadius: '10px'}}>
          {combinedSummaryData ? (
      <>
                <div style={{padding: '0px 15px',
    borderRight: '1px solid #C4D3D8'}}>
                  <p style={{
                    fontSize: '17px',
                    color: '#B5B9BA',
                    marginBottom: '5px'
                  }}>Peak Month</p>
                  {activeTable === "weekday" && (
                  // <h4>{combinedSummaryData.combined_summary.overall_peak_summary.peak_month}</h4>
                  <h4>{combinedSummaryData?.combined_summary?.weekday?.peak_month}</h4>
                )}
                {activeTable === "weekend" && (
                  // <h4>{combinedSummaryData.combined_summary.overall_peak_summary.peak_month}</h4>
                  <h4>{combinedSummaryData?.combined_summary?.weekend?.peak_month}</h4>
                )}
                </div>
                <div style={{padding: '0px 15px'}}>
                  <p style={{
                    fontSize: '17px',
                    color: '#B5B9BA',
                    marginBottom: '5px'
                  }}>Peak Period</p>
                  {/* <h4>6 PM</h4> */}
                  {activeTable === "weekday" && (
                  // <h4>{combinedSummaryData.combined_summary.overall_peak_summary.peak_hour}</h4>
                  <h4>{combinedSummaryData?.combined_summary?.weekday?.peak_hour}</h4>
                )}
                {activeTable === "weekend" &&(
                  <h4>{combinedSummaryData?.combined_summary.weekend?.peak_hour}</h4>
                )}
                </div>
                </>
          ):<></>}
              </div>
     
            </div>

            <div className="w-100 mt-3 overview-table">
              {/* Conditional rendering of tables based on state */}
              {activeTable === "weekday" && (
                <table className="table table-weekday">
                  <thead>
                    <tr>
                      <td className="text-center">Land Usage</td>
                      <td className="text-center">Size</td>
                      <td className="text-center">Peak Month</td>
                      <td className="text-center">Peak Hour</td>
                      <td className="text-center">Peak Value</td>
                    </tr>
                  </thead>
                  <tbody>
                  {parkingDemandData.map((item, index) => (
                     <tr key={index}>
                      <td className="text-center">
                        {/* {item.land_use_type} */}
                        {item.land_use_type.replace(/\s*Typical$/, '')}
                        
                        </td>
                      <td className="text-center">{item.project_data.quantity} {item.project_data.unit}</td>

                      {/* <td className="text-center">{item.weekday.peak_month_name}</td>
                      <td className="text-center">{item.weekday.peak_hour_time}</td>
                      <td className="text-center">{item.weekday.peak_month}</td> */}

                      <td className="text-center">{item.peaktable_data.weekday_peak.month}</td>
                      <td className="text-center">{item.peaktable_data.weekday_peak.time}</td>
                      <td className="text-center">{item.peaktable_data.weekday_peak.value}</td>
                    </tr>
                  ))}
     
                  </tbody>
                </table>
              )}
              {activeTable === "weekend" && (
                <table className="table table-weekend">
                  <thead>
                    <tr>
                    <td className="text-center">Land Usage</td>
                      <td className="text-center">Size</td>
                      <td className="text-center">Peak Month</td>
                      <td className="text-center">Peak Hour</td>
                      <td className="text-center">Peak Value</td>
                    </tr>
                  </thead>
                  <tbody>
                  {parkingDemandData.map((item, index) => (
                     <tr key={index}>
                      <td className="text-center">
                        {/* {item.land_use_type} */}
                        {item.land_use_type.replace(/\s*Typical$/, '')}
                        </td>
                      <td className="text-center">{item.project_data.quantity} {item.project_data.unit}</td>

                      {/* <td className="text-center">{item.weekend.peak_month_name}</td>
                      <td className="text-center">{item.weekend.peak_hour_time}</td>
                      <td className="text-center">{item.weekend.peak_month}</td> */}

                      <td className="text-center">{item.peaktable_data.weekend_peak.month}</td>
                      <td className="text-center">{item.peaktable_data.weekend_peak.time}</td>
                      <td className="text-center">{item.peaktable_data.weekend_peak.value}</td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
       
          <div ref={secondDivRef} className="card-inside">
            <div className="d-flex align-items-center justify-content-between">    
              <div>
              {activeTableMonthly === "monthly" && (
             <h4 className="mb-1">Monthly Peak Comparison</h4>
              )}
               {activeTableMonthly === "hourly" && (
             <h4 className="mb-1">Hourly Peak Comparison</h4>
               )}
            {/* <p>Weekday</p>      */}
            {activeTable === "weekday" && <p>Weekday</p>}
            {activeTable === "weekend" && <p>Weekend</p>}
            </div>  
            <div className="d-flex align-items-center" style={{ borderRadius: '5px'}}>
                  {/* Weekday and Weekend buttons */}
                  <div
                    onClick={() => setActiveTableMonthly("monthly")}
                    style={{
                      cursor: "pointer",
                      padding: '18px 40px',
                      fontWeight: '300',
                      background: activeTableMonthly === "monthly" ? "#E49492" : "#ECF4F5",
                      borderRadius: '5px 0 0 5px',
                    }}
                  >
                    <h4 style={{fontSize: '15px', fontWeight: '400',
                   color: activeTableMonthly === "monthly" ? "#fff" : "#000",
                  }} className="mb-0">Monthly</h4>
                  </div>
                  <div
                    onClick={() => setActiveTableMonthly("hourly")}
                    style={{
                      cursor: "pointer",
                      padding: '18px 40px',
                      fontWeight: '300',
                      background: activeTableMonthly === "hourly" ? "#E49492" : "#ECF4F5",
                      borderRadius: '0 5px 5px 0'
                    }}
                  >
                    <h4 style={{fontSize: '15px', fontWeight: '400',
                    color: activeTableMonthly === "hourly" ? "#fff" : "#000",
                  }} className="mb-0">Hourly</h4>
                  </div>
                </div>
            </div>
                      
                        <Heatmap
                          data={heatmapData}
                          rowNames={rowNames}
                          columnNames={columnNames}
                          height={activeTableMonthly === "monthly" ? 380 : 500} // Customize height
                          fontSize={14} // Customize font size
                          fontColor="black" // Customize font color
                          showValues={true}
                          baseColor="#E49492"
                          legendPosition="bottom"
                          gapBetweenCells={false}
                          showXAxisLine={false}
                          showYAxisLine={false}
                          showStroke={true}
                          />
                         
          </div>
        </div>
      </div>
      <div  className="row mt-3">
        {activeTable == "weekday" && (<>
        <div ref={weekdayBarGraphSnap} className="col-lg-6">
          <div className="card-inside">
            <h4>
              {/* {parkingDemandData[0].weekday.month_graph.title} */}
              {/* Weekday Peak Parking Demand by Month */}
              Weekday Peak Month Parking Distribution
            </h4>
            <div className="graph-section mt-5">
             

              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  data={formattedData}
                  // margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                  margin={{ top: 20, right: 10, left: 10, bottom: 5 }}
                >
                  {/* Define gradient colors */}
                  <defs>
                   
                    <defs>
                    <linearGradient id="darkerBlue" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#4682B4" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#5F9EA0" stopOpacity={0.8} />
                    </linearGradient>
                    <linearGradient id="darkerPeach" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#D78B4C" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#C16D45" stopOpacity={0.8} />
                    </linearGradient>
                    <linearGradient id="darkerPink" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#DB7093" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#C71585" stopOpacity={0.8} />
                    </linearGradient>
                    <linearGradient id="darkerCyan" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#00CED1" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#20B2AA" stopOpacity={0.8} />
                    </linearGradient>
                    <linearGradient id="darkerOrange" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#D2691E" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#CD853F" stopOpacity={0.8} />
                    </linearGradient>
                  </defs>

                  </defs>

                  <CartesianGrid
                    strokeDasharray="9 9"
                    vertical={false}
                    strokeOpacity={0.6}
                  />
                  <XAxis dataKey="month" tickLine={false} dy={5} interval={0}/>
                  <YAxis axisLine={false} tickLine={false} dx={-25} />
                  {/* <Tooltip /> */}
                  <Tooltip 
                      // formatter={(value, name) => [value, name.replace(/\s*Typical$/, '')]} 
                      content={({ payload, label }) => {
                        if (!payload || payload.length === 0) return null; // Avoid errors
                    
                        // Extracting total sum of all categories except "month"
                        const totalSum = Object.keys(payload[0].payload)
                          .filter((key) => key !== "month")
                          .reduce((sum, key) => sum + (payload[0].payload[key] || 0), 0);
                    
                        return (
                          <div style={{ backgroundColor: "#fff", padding: "10px", border: "1px solid #ccc" }}>
                            <p><strong>{label}</strong></p>
                            {payload.map((entry, index) => (
                              <p key={index} style={{ color: entry.color }}>
                                {entry.name.replace(/\s*Typical$/, '')}: {entry.value}
                              </p>
                            ))}
                            <p style={{ fontWeight: "bold", color: "#333" }}>Overall value: {totalSum}</p>
                          </div>
                        );
                      }}
                    />

                      {/* Custom Legend Formatter to remove "Typical" */}
                      <Legend formatter={(value) => value.replace(/\s*Typical$/, '')} />

                  {/* Render bars for each land_use_type dynamically with fixed gradient colors */}
                  {parkingDemandData.map((item, index) => {
                    const gradientIds = [
                      "darkerBlue",
                      "darkerPeach",
                      "darkerPink",
                      "darkerCyan",
                      "darkerOrange",
                    ];
                    
                    const gradientId = gradientIds[index % gradientIds.length]; // Cycle through the gradients
                    return (
                      <Bar
                        key={item.land_use_type}
                        dataKey={item.land_use_type}
                        stackId="a"
                        fill={`url(#${gradientId})`}
                        barSize={27}
                      />
                    );
                  })}
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        <div ref={weekdayLineGraphSnap} className="col-lg-6">
          <div className="card-inside">
            <h4>
              {/* {parkingDemandData[0].weekday.time_graph.title} */}
              {/* Weekday Peak Parking Demand Over Time */}
              Hourly Distribution of Weekday Peak Parking Demand
            </h4>
            <div className="graph-section mt-5">
              

              <ResponsiveContainer width="100%" height={400}>
                <LineChart
                  data={formattedTimeData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  {/* Define gradient colors */}
                  {/* <defs>
                  
                  <linearGradient id="darkerBlue" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#4682B4" stopOpacity={1} />
                      <stop offset="95%" stopColor="#5F9EA0" stopOpacity={1} />
                    </linearGradient>
                    <linearGradient id="darkerPeach" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#D78B4C" stopOpacity={1} />
                      <stop offset="95%" stopColor="#C16D45" stopOpacity={1} />
                    </linearGradient>
                    <linearGradient id="darkerPink" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#DB7093" stopOpacity={1} />
                      <stop offset="95%" stopColor="#C71585" stopOpacity={1} />
                    </linearGradient>
                    <linearGradient id="darkerCyan" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#00CED1" stopOpacity={1} />
                      <stop offset="95%" stopColor="#20B2AA" stopOpacity={1} />
                    </linearGradient>
                    <linearGradient id="darkerOrange" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#D2691E" stopOpacity={1} />
                      <stop offset="95%" stopColor="#CD853F" stopOpacity={1} />
                    </linearGradient>
                  </defs> */}

                  <CartesianGrid
                    strokeDasharray="9 9"
                    vertical={false}
                    strokeOpacity={0.6}
                  />
                  <XAxis dataKey="time" tickLine={false} dy={5} />
                  <YAxis axisLine={false} tickLine={false} dx={-25} />

                      
                    <Tooltip 
                      formatter={(value, name) => [value, name.replace(/\s*Typical$/, '')]} />          
                      <Legend formatter={(value) => value.replace(/\s*Typical$/, '')} />

                  {/* Render Lines for each land_use_type dynamically with fixed gradient colors */}
                  {Object.keys(formattedTimeData[0])
                    .filter((key) => key !== "time") 
                    .map((landUseType, index) => {
                      
                      // const gradientIds = [
                      //   "darkerBlue",
                      //   "darkerPeach",
                      //   "darkerPink",
                      //   "darkerCyan",
                      //   "darkerOrange",
                      // ];
                      
                      
                      // const gradientId =
                      //   gradientIds[index % gradientIds.length]; 

                      const colors = [
                        "#4682B4",
                        "#D78B4C",
                        "#DB7093",
                        "#00CED1",
                        "#D2691E",
                      ];
                      const color = colors[index % colors.length];
                      return (
                        <Line
                          key={landUseType}
                          type="monotone"
                          dataKey={landUseType}
                          // stroke={`url(#${gradientId})`}
                          stroke={color}
                          name={landUseType}
                          strokeWidth={2}
                          dot={false}
                        />
                      );
                    })}

                    {/* Render Combined Summary as a separate dotted line */}
                    {combinedSummaryTimeData.length > 0 && (
                      <Line
                        type="monotone"
                        data={combinedSummaryTimeData} // Use the separate data for the combined summary
                        dataKey="Combined Summary"
                        stroke="black"
                        name="Overall Value"
                        strokeWidth={2}
                        dot={false}
                        strokeDasharray="3 3" // Dashed line style
                      />
                    )}
          
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        
        </div>
        </>
        )}
       
        {activeTable == "weekend" && (<>
        <div ref={weekendBarGraphSnap} className="col-lg-6">
          <div className="card-inside">
            <h4>
              {/* {parkingDemandData[0].weekend.month_graph.title} */}
              {/* Weekend Peak Parking Demand by Month */}
              Weekend Peak Month Parking Distribution
            </h4>
            <div className="graph-section mt-5">
              

              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  data={formattedWeekendData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  {/* Define gradient colors */}
                  <defs>
                    <linearGradient id="darkerBlue" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#4682B4" stopOpacity={0.8} />{" "}
                      {/* Darker Blue */}
                      <stop
                        offset="95%"
                        stopColor="#5F9EA0"
                        stopOpacity={0.8}
                      />{" "}
                      {/* Slightly darker Blue-Green */}
                    </linearGradient>
                    <linearGradient
                      id="darkerPeach"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="5%" stopColor="#D78B4C" stopOpacity={0.8} />{" "}
                      {/* Darker Peach */}
                      <stop
                        offset="95%"
                        stopColor="#C16D45"
                        stopOpacity={0.8}
                      />{" "}
                      {/* Darker Peach-Red */}
                    </linearGradient>
                    <linearGradient id="darkerPink" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#DB7093" stopOpacity={0.8} />{" "}
                      {/* Darker Pink */}
                      <stop
                        offset="95%"
                        stopColor="#C71585"
                        stopOpacity={0.8}
                      />{" "}
                      {/* Darker Medium Violet Red */}
                    </linearGradient>
                    <linearGradient id="darkerCyan" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#00CED1" stopOpacity={0.8} />{" "}
                      {/* Darker Cyan */}
                      <stop
                        offset="95%"
                        stopColor="#20B2AA"
                        stopOpacity={0.8}
                      />{" "}
                      {/* Darker Light Sea Green */}
                    </linearGradient>

                    <linearGradient
                      id="darkerOrange"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="5%" stopColor="#D2691E" stopOpacity={0.8} />{" "}
                      {/* Darker Orange */}
                      <stop
                        offset="95%"
                        stopColor="#CD853F"
                        stopOpacity={0.8}
                      />{" "}
                      {/* Darker Sandy Orange */}
                    </linearGradient>
                  </defs>

                  <CartesianGrid
                    strokeDasharray="9 9"
                    vertical={false}
                    strokeOpacity={0.6}
                  />
                  <XAxis dataKey="month" tickLine={false} dy={5} interval={0}/>
                  <YAxis axisLine={false} tickLine={false} dx={-25} />
                  {/* <Tooltip />
                  <Legend /> */}
                  <Tooltip 
                      // formatter={(value, name) => [value, name.replace(/\s*Typical$/, '')]} 
                      content={({ payload, label }) => {
                        if (!payload || payload.length === 0) return null; // Avoid errors
                    
                        // Extracting total sum of all categories except "month"
                        const totalSum = Object.keys(payload[0].payload)
                          .filter((key) => key !== "month")
                          .reduce((sum, key) => sum + (payload[0].payload[key] || 0), 0);
                    
                        return (
                          <div style={{ backgroundColor: "#fff", padding: "10px", border: "1px solid #ccc" }}>
                            <p><strong>{label}</strong></p>
                            {payload.map((entry, index) => (
                              <p key={index} style={{ color: entry.color }}>
                                {entry.name.replace(/\s*Typical$/, '')}: {entry.value}
                              </p>
                            ))}
                            <p style={{ fontWeight: "bold", color: "#333" }}>Overall value: {totalSum}</p>
                          </div>
                        );
                      }}
                    />

                      {/* Custom Legend Formatter to remove "Typical" */}
                      <Legend formatter={(value) => value.replace(/\s*Typical$/, '')} />

                  {/* Render bars for each land_use_type dynamically with fixed gradient colors */}
                  {parkingDemandData.map((item, index) => {
                    // Using modulo to cycle through gradient colors
                    const gradientIds = [
                      "darkerBlue",
                      "darkerPeach",
                      "darkerPink",
                      "darkerCyan",
                      "darkerOrange",
                    ];
                    const gradientId = gradientIds[index % gradientIds.length]; // Cycle through the gradients
                    return (
                      <Bar
                        key={item.land_use_type}
                        dataKey={item.land_use_type}
                        stackId="a"
                        fill={`url(#${gradientId})`}
                        barSize={27}
                      />
                    );
                  })}
                  
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
          
        </div>
      
        
        <div ref={weekendLineGraphSnap} className="col-lg-6">
          <div className="card-inside">
            <h4>
              {/* {parkingDemandData[0].weekend.time_graph.title} */}
              {/* Weekend Peak Parking Demand Over Time */}
              Hourly Distribution of Weekend Peak Parking Demand
            </h4>
            <div className="graph-section mt-5">
              

              <ResponsiveContainer width="100%" height={400}>
                <LineChart
                  data={formattedTimeWeekendData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  
                  {/* <defs>
                    <linearGradient id="darkerBlue" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#4682B4" stopOpacity={0.8} />{" "}
                      <stop
                        offset="95%"
                        stopColor="#5F9EA0"
                        stopOpacity={0.8}
                      />{" "}
                    </linearGradient>
                    <linearGradient
                      id="darkerPeach"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="5%" stopColor="#D78B4C" stopOpacity={0.8} />{" "}
                      <stop
                        offset="95%"
                        stopColor="#C16D45"
                        stopOpacity={0.8}
                      />{" "}
                    </linearGradient>
                    <linearGradient id="darkerPink" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#DB7093" stopOpacity={0.8} />{" "}
                      <stop
                        offset="95%"
                        stopColor="#C71585"
                        stopOpacity={0.8}
                      />{" "}
                    </linearGradient>
                    <linearGradient id="darkerCyan" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#00CED1" stopOpacity={0.8} />{" "}
                      <stop
                        offset="95%"
                        stopColor="#20B2AA"
                        stopOpacity={0.8}
                      />{" "}
                    </linearGradient>

                    <linearGradient
                      id="darkerOrange"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="5%" stopColor="#D2691E" stopOpacity={0.8} />{" "}
                      <stop
                        offset="95%"
                        stopColor="#CD853F"
                        stopOpacity={0.8}
                      />{" "}
                    </linearGradient>
                  </defs> */}

                  <CartesianGrid
                    strokeDasharray="9 9"
                    vertical={false}
                    strokeOpacity={0.6}
                  />
                  <XAxis dataKey="time" tickLine={false} dy={5} />
                  <YAxis axisLine={false} tickLine={false} dx={-25} />

                    <Tooltip 
                      formatter={(value, name) => [value, name.replace(/\s*Typical$/, '')]} 
                    />

                      
                      <Legend formatter={(value) => value.replace(/\s*Typical$/, '')} />

                  {/* Render Lines for each land_use_type dynamically with fixed gradient colors */}
                  {Object.keys(formattedTimeData[0])
                    .filter((key) => key !== "time") // Filter out 'time' key, leaving only land_use_types
                    .map((landUseType, index) => {
                      // const gradientIds = [
                      //   "darkerBlue",
                      //   "darkerPeach",
                      //   "darkerPink",
                      //   "darkerCyan",
                      //   "darkerOrange",
                      // ];
                      // const gradientId =
                      //   gradientIds[index % gradientIds.length]; 
                      const colors = [
                        "#4682B4",
                        "#D78B4C",
                        "#DB7093",
                        "#00CED1",
                        "#D2691E",
                      ];
                      const color = colors[index % colors.length];
                      return (
                        <Line
                          key={landUseType}
                          type="monotone"
                          dataKey={landUseType}
                          // stroke={`url(#${gradientId})`}
                          stroke={color}
                          name={landUseType}
                          strokeWidth={2}
                          dot={false}
                        />
                      );
                    })}
                    {/* Render Combined Summary as a separate dotted line */}
                    {combinedSummaryTimeData_Weekend.length > 0 && (
                      <Line
                        type="monotone"
                        data={combinedSummaryTimeData_Weekend} // Use the separate data for the combined summary
                        dataKey="Combined Summary"
                        stroke="black"
                        name="Overall Value"
                        strokeWidth={2}
                        dot={false}
                        strokeDasharray="3 3" // Dashed line style
                      />
                    )}
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        </>
        )}

      </div>
    </div>
  );
};

export default OverviewDasboard;
